import React, { useEffect } from 'react';
import { Modal } from '../_components';
import { useModal } from '../_contexts';
import { MarkerTemplateForm, MarkerTemplatesListForm } from './forms';
import { useSelector } from 'react-redux';

export function MarkerTemplates(props) {
  const { closeModal } = useModal();
  const { details: world } = useSelector((state) => state.world);
  return (
    <Modal
      id="markerTemplateManager"
      title="Marker Templates"
      icon="far fa-map-marker-edit fa-fw"
      onClose={closeModal}
      size="md"
      // backdrop
      open
    >
      {/* <MarkerTemplateForm />{' '} */}
      <MarkerTemplatesListForm worldID={world && world._id} />
      {/* TODO: Switch this out with the Manager (list of presets) */}
    </Modal>
  );
}
